import { useState } from 'react';
import { Zap } from 'lucide-react';
import { Button } from '@/components/ui/button';
import type { PcmpChannel } from '../../types/pcmpProposal.types';
import { PcmpRequestSubmitDialog } from './PcmpRequestSubmitDialog';

interface PcmpRequestButtonProps {
  proposalId: number;
  refNo: string;
  proposedAmount: number;
  /** Who pays it: a Payment Return asks for the deposit slip of an Accounts payout. */
  paymentSource: PcmpChannel;
  canRequest: boolean;
}

/** Raise a priority request on this proposal, from the API's canRequest. */
export function PcmpRequestButton({
  proposalId,
  refNo,
  proposedAmount,
  paymentSource,
  canRequest,
}: PcmpRequestButtonProps) {
  const [open, setOpen] = useState(false);

  // An open dialog outlives the capability (the request it raised closes the
  // option), so a refresh must not unmount it.
  if (!canRequest && !open) return null;

  return (
    <>
      {canRequest ? (
        <Button
          type="button"
          size="sm"
          variant="outline"
          onClick={() => setOpen(true)}
          className="gap-1.5"
        >
          <Zap className="size-3.5" />
          Request
        </Button>
      ) : null}
      {/* Mounted only while open, so it starts empty. */}
      {open ? (
        <PcmpRequestSubmitDialog
          target={{
            count: 1,
            amount: proposedAmount,
            selection: { proposalIds: [proposalId] },
            items: [{ proposalId, refNo, paymentSource }],
          }}
          refNoOf={() => refNo}
          onSubmitted={() => undefined}
          onClose={() => setOpen(false)}
        />
      ) : null}
    </>
  );
}
